const images = {
    gmain: require('../assets/images/gallary-img1.png'),
    g1: require('../assets/images/gallary-img2.png'),
    g2: require('../assets/images/gallary-img3.png'),
    g3: require('../assets/images/gallary-img4.png'),
    g4: require('../assets/images/gallary-img5.png'),
    g5: require('../assets/images/gallary-img6.png'),
    g6: require('../assets/images/gallary-img7.png'),
    g7: require('../assets/images/gallary-img8.png'),
    g8: require('../assets/images/gallary-img9.png'),
    g9: require('../assets/images/gallary-img10.png'),
    g10: require('../assets/images/gallary-img11.png'),
    g11: require('../assets/images/gallary-img12.png'),
    g12: require('../assets/images/gallary-img13.png'),

    amain: require('../assets/images/Apart-img1.png'),
    a1: require('../assets/images/Apart-2.png'),
    a2: require('../assets/images/Apart-3.png'),
    a3: require('../assets/images/Apart-4.png'),
    a4: require('../assets/images/Apart-5.png'),
    a5: require('../assets/images/Apart-6.png'),
    a6: require('../assets/images/Apart-7.png'),
    a7: require('../assets/images/Apart-8.png'),
    a8: require('../assets/images/Apart-9.png'),

    Amain: require('../assets/images/Amenities-img1.png'),
    A1: require('../assets/images/Group.png'),
    A2: require('../assets/images/Vector2.png'),
    A3: require('../assets/images/Group (1).png'),
    A4: require('../assets/images/Group (2).png'),
    A5: require('../assets/images/Group (3).png'),
    A6: require('../assets/images/Group (3)2.png'),
    A7: require('../assets/images/Group (4).png'),
    A8: require('../assets/images/Group (5).png'),
    A9: require('../assets/images/Group (6).png'),
    A10: require('../assets/images/Group (7).png'),
    A11: require('../assets/images/Group (8).png'),
    A12: require('../assets/images/Group (9).png'),
    A13: require('../assets/images/Group (10).png'),

    Cmain: require('../assets/images/contactus-img1.png'),
    C1: require('../assets/icons/contactus-ic1.png'),
    C2: require('../assets/icons/contactus-ic2.png'),
    C3: require('../assets/icons/contactus-ic3.png'),
    C4: require('../assets/icons/contactus-ic4.png'),
    C5: require('../assets/icons/contactus-ic5.png'),
    C6: require('../assets/icons/contactus-ic6.png'),


    





 
};

export default images;